/**
 * Footer links to published legal documents.
 * Defaults to in-app pages at /legal/terms and /legal/privacy (and /legal/aup).
 * Override at build time with absolute URLs if you host them elsewhere:
 *   VITE_TERMS_URL=https://birdmansuite.com/legal/terms
 *   VITE_PRIVACY_URL=https://birdmansuite.com/legal/privacy
 *   VITE_AUP_URL=https://birdmansuite.com/legal/aup
 * Source templates live in /legal at the repo root.
 */
export interface LegalLink {
  label: string;
  url: string;
}

export const DEFAULT_LEGAL_PATHS = {
  terms: '/legal/terms',
  privacy: '/legal/privacy',
  aup: '/legal/aup',
} as const;

const clean = (value: string | undefined): string | undefined => {
  const v = value?.trim();
  return v ? v : undefined;
};

export function getTermsUrl(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  return clean(env.VITE_TERMS_URL) || DEFAULT_LEGAL_PATHS.terms;
}

export function getPrivacyUrl(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  return clean(env.VITE_PRIVACY_URL) || DEFAULT_LEGAL_PATHS.privacy;
}

export function getAupUrl(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  return clean(env.VITE_AUP_URL) || DEFAULT_LEGAL_PATHS.aup;
}

export function getLegalLinks(): LegalLink[] {
  return [
    { label: 'Terms', url: getTermsUrl() },
    { label: 'Privacy', url: getPrivacyUrl() },
    { label: 'Acceptable use', url: getAupUrl() },
  ];
}
